import api from './api';

const resourceRoleMasterService = {
  // Get all resource role masters with pagination and filters
  getAllResourceRoleMasters: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add filter parameters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.category) queryParams.append('category', params.category);
      if (params.level) queryParams.append('level', params.level);
      
      const response = await api.get(`/resource-role-masters?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching resource role masters:', error);
      throw error;
    }
  },

  // Get resource role master by ID
  getResourceRoleMasterById: async (id) => {
    try {
      const response = await api.get(`/resource-role-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching resource role master:', error);
      throw error;
    }
  },

  // Create new resource role master
  createResourceRoleMaster: async (resourceRoleMasterData) => {
    try {
      const response = await api.post('/resource-role-masters', resourceRoleMasterData);
      return response.data;
    } catch (error) {
      console.error('Error creating resource role master:', error);
      throw error;
    }
  },

  // Update resource role master
  updateResourceRoleMaster: async (id, resourceRoleMasterData) => {
    try {
      const response = await api.put(`/resource-role-masters/${id}`, resourceRoleMasterData);
      return response.data;
    } catch (error) {
      console.error('Error updating resource role master:', error);
      throw error;
    }
  },

  // Delete resource role master (soft delete)
  deleteResourceRoleMaster: async (id) => {
    try {
      const response = await api.delete(`/resource-role-masters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting resource role master:', error);
      throw error;
    }
  },

  // Get resource role master statistics
  getResourceRoleMasterStats: async () => {
    try {
      const response = await api.get('/resource-role-masters/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching resource role master stats:', error);
      throw error;
    }
  }
};

export default resourceRoleMasterService;
